module.exports = __webpack_public_path__ + "img/triangle4green.a8342c3f.png";